export default "__VITE_ASSET__CAzKSNUx__"